///<reference path="../../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.ts" />

import { DetailState, IIsiDtoGridColumn, IIsiDtoMenuObject, IsiDtoAssociatedViewManagerClientState, IsiDtoIwsAssociatedViewClientState } from "../../../Dtos/Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoSelectedRecordSet } from "../../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlMark";
import { Mode, SaveMode } from "../../../Dtos/Isilog.IsiFramework.IsiDataTransferObject.IsiGrid";
import { iws_RegisterLastAction } from "../../../form.ts";
import { IsiIconType, IsiSearchType, MenuItemCode } from "../../../Isilog.enums";
import { IsiFillReplace } from "../../../Isilog.popins";
import { modifWaitStatus } from "../../../IsiPage.ts";
import { IsiIwsAssociatedView } from "../../../IsiWebGUI/Components/Grid/IsiIwsAssociatedView.component";
import { IsiIwsTabularView } from "../../../IsiWebGUI/Components/Grid/IsiIwsTabularView.component";
import { IIsiDtoColumnTemplate, IIsiGridOnLoadOnDemandCompletedEventArgs, IIsiGridValidationContext, IIsiGridRowDragStartArgs } from "../../../IsiWebGUI/IsiFW/Components/Grid/IsiGridBase";
import { IsiGridView } from "../../../IsiWebGUI/IsiFW/Components/Grid/IsiGridView";
import { IsiHorizontalMenu } from "../../../IsiWebGUI/IsiFW/Components/Menu/HorizontalMenu/IsiHorizontalMenu.component";
import { IsiComponentManager } from "../../../IsiWebGUI/IsiFW/Core/Manager/IsiComponentManager";
import { iws_GetPageName } from "../../../tools.ts";
import { IIsiUIFlowResult } from "../../Core/IIsiUIFlowResult";
import { IIsiUIFlowResultGeneric } from "../../Core/IIsiUIFlowResultGeneric";
import { IsiActionContext } from "../../Core/IsiActionContext";
import { IsiIwsGridSavingBehaviour } from "../../Grid/IsiIwsGridSavingBehaviour";
import { IsiAddInstancePopin } from "../../Popin/IsiPopin/IsiAddInstancePopin";
import { IsiPlAssociatedViewManager } from "../../PresentationLogic/IsiPlAssociatedViewManager";
import { IsiPlDelete } from "../../PresentationLogic/IsiPlDelete";
import { IsiPlHierarchical } from "../../PresentationLogic/IsiPlHierarchical";
import { IsiPlMark, MarkUnmarkOpt } from "../../PresentationLogic/IsiPlMark";
import { IsiPlMergeModel } from "../../PresentationLogic/IsiPlMergeModel";
import { IsiPlRestore } from "../../PresentationLogic/IsiPlRestore";
import { IsiArchiveProvider } from "./IsiArchiveProvider";
import { IsiIWSAssociatedView } from "./IsiAssociatedView";
import { HandlerType, IsiAssociatedViewCountProvider } from "./IsiAssociatedViewCountProvider";
import { IsiAssociatedViewXmlJoinManager } from "./IsiAssociatedViewXmlJoinManager";
import { IsiDissociationProvider } from "./IsiDissociationProvider";
import { IsiIWSAssociatedViewContext } from "./IsiIwsAssociatedViewContext";
import { IsiReorganizationProvider } from "./IsiReorganizationProvider";




export class IsiDetailManager {

    _state: IsiDtoAssociatedViewManagerClientState;

    // Indique qu'un detail existe sur la page.
    private _exist: boolean = false;

    // Indique que la zone de detail a le focus.
    private _hasFocus: boolean = false;

    //---------------------------------------------------------------
    // Private members
    //---------------------------------------------------------------

    private _btnValidateClick: boolean;
    private _closeDemanded: boolean = false;
    private _upDemanded: boolean = false;
    private _displayViewByCtrl: boolean = false;
    //private _state = DetailPosition.none;
    private _gripHeight: number;
    private _draggingInProgress: boolean = false;
    private _doubleClicked = false;
    private _ajax = null;
    private _detail = null;
    private _initialized: boolean = false;

    private _splitterDetail: { top: number, offsetTop: number } = { top: 0, offsetTop: 0 };

    private _lastDragTopPostion: number;

    private _maxHeight: number;
    private _shownContextChangedByUser: boolean;
    private _shownContext: IsiIWSAssociatedViewContext;
    private _associatedViewsComponents: { [key: string]: IsiIwsAssociatedView; } = {};
    private _associatedViews: { [key: string]: IsiIWSAssociatedView; } = {};

    //private _mainContext: IIsiDtoAssociatedViewClientState;
    // Evenement sur le Grip de la DA
    private _onGripMouseUpHandlers: ((sender: IsiDetailManager) => void)[];

    private _currentComponent: IsiIwsAssociatedView;

    private _associatedViewCountProvider: IsiAssociatedViewCountProvider;
    /**Délégué appelé lorsque l'on demande l'affichage d'une da ou pas.*/
    private _displayedAssociatedViewChanged: (assViewId: string) => void;

    private _xmlJoinManager: IsiAssociatedViewXmlJoinManager;
    private _gridCount: number;

    /**
     * Interdit le refresh du composant par raccourci sur une courte période (pour empecher l'utilisateur de spam)
     */
    private _disableKeyboardRefresh: boolean = false;

    /**
     * Durée en millisecondes entre deux refresh pour laisser le temps à la requete de s'effectuer correctement
     */
    private readonly _dureeMinimaleEntreDeuxRefresh: number = 300;
    private _Refresh = "Refresh";
    private _Reinit = "Reinit";
    private _None = "None";

    private readonly _benchKeyGridFullLoad = "gridFullLoad";


    constructor(state: IsiDtoAssociatedViewManagerClientState) {
        this._state = state;
        this._associatedViewCountProvider = new IsiAssociatedViewCountProvider();
        this._xmlJoinManager = new IsiAssociatedViewXmlJoinManager();
        screenCore.whenUICoreCreated(() => {
            uiCore.whenComponentManagerFound((componentManager: IsiComponentManager) => {
                componentManager.whenComponentFound<any>("associatedViewFormVerticalMenu", (cp) => {
                    this._displayedAssociatedViewChanged = (assViewId) => {
                        cp.changeSelection(`[id$='${MNU_SEP + assViewId}']`);
                    }
                    cp.add_onEntryClicked((sender, args) => {
                        this.associatedViewFormVerticalMenuClicked(uiCore.menuManager.getEntryById(args.entry.id));
                    });
                });
            });
        });
        screenCore.whenUICoreCreated(() => {
            uiCore.whenComponentManagerFound((componentManager: IsiComponentManager) => {
                componentManager.whenComponentFound<IsiHorizontalMenu>("associatedViewFormHorizontalMenu", (cp) => {
                    cp.add_entryClicked((sender, args) => {
                        this.associatedViewFormVerticalMenuClicked(uiCore.menuManager.getEntryById(args.entryId));
                    });
                });
            });
        });

        if (this._state) {
            for (var i in this._state.states) {
                let state = this._state.states[i];
                let context = new IsiIWSAssociatedViewContext(uiCore.componentManager, state.gridViewId, state);

                if (context.id == this._state.shownContextId) {
                    this._shownContext = context;
                }
                context.cellDoubleClicked = function (me, c) {
                    return function (cellId: string) {
                        return me._cellDoubleClicked(c, cellId);
                    }
                }(this, context)

                context.componentInitialized = (associatedView) => {
                    this._associatedViewInitialized(associatedView, context);
                }
                screenCore.gridManager.registerContext(context, this.mainContext?.id == context.id);

                screenCore.whenUICoreCreated(() => {
                    this._ensureInitialized();
                    uiCore.whenComponentManagerFound((componentManager: IsiComponentManager) => {
                        let gridViewId = context.gridViewId;

                        componentManager.whenComponentFound<IsiIwsAssociatedView>(gridViewId, (cp) => {
                            cp.context = context;
                            this._associatedViewFound(cp, context);
                        });
                        componentManager.whenComponentInitialized<IsiIwsAssociatedView>(gridViewId, (cp) => {
                            cp.context = context;
                            this._associatedViewInitialized(cp, context);
                        });
                    });
                });
            }
        }
    }

    /**
     *  renvoi la liste des controles mis à jour permettant l'évaluation de la requête de la da.
     * @param associatedViewCtx
     * @returns
     */
    public getLinkedCtrlsValues(associatedViewCtx: IsiIWSAssociatedViewContext): { [key: string]: string; } {
        return this._xmlJoinManager.getUpdatedJoinCtrls(associatedViewCtx);
    }

    /**
     * renvoi le gestionnaire de comptage d'élément de DA.
     */
    public get associatedViewCountProvider() {
        return this._associatedViewCountProvider;
    }
    public associatedViewFormVerticalMenuClicked(dtoMenuObj: IIsiDtoMenuObject) {
        this.associatedViewFormVerticalMenuClickedWithEvent(dtoMenuObj, null);
    }

    public associatedViewFormVerticalMenuClickedWithEvent(dtoMenuObj: IIsiDtoMenuObject, event: Event) {
        if (dtoMenuObj.key === DATA_ADDv2) {
            this.addOnAssociatedView(dtoMenuObj, event);
        } else {
            this.showAssociatedviewOnVerticalMenuClick(dtoMenuObj)
        }
    }
    /**
 * Indique qu'une da va se charger.
 * @returns
 */
    public isShowing(): boolean {
        return this?._state?.shownContextId !== "" && this?._state?.shownContextId !== null && this?._state?.shownContextId !== undefined;
    }
    /**
   * Lance l'ajout dans la da depuis le menu vertical de gauche.
   * @param dtoMenuObj
   */
    private addOnAssociatedView(dtoMenuObj: IIsiDtoMenuObject, event: Event) {
        const assContextId = dtoMenuObj.data["assContextId"];
        const detailBarId = dtoMenuObj.data["barId"];
        const assViewContext = this.getContext(assContextId);
        const actionContext = new IsiActionContext();
        // cas d'une menu avec sous menu
        let menu = screenCore.menuManager.getEntryById(detailBarId + MNU_SEP + DATA_MNUGRP_NAVIGATION + MNU_SEP + dtoMenuObj.id);
        if (!menu) {
            // cas d'un menu sans instance
            menu = screenCore.menuManager.getEntryById(detailBarId + MNU_SEP + DATA_MNUGRP_NAVIGATION + MNU_SEP + assViewContext.name + MNU_SEP + dtoMenuObj.id);
        }
        actionContext.menu = menu;
        actionContext.associatedViewContext = assViewContext;
        if (event && (!jQuery(event.target).data("actionmenu") || jQuery(event.target).data("actionmenu") !== true)) {
            this._state.shownContextId = dtoMenuObj.data.assContextId;
        }
        screenCore.uiActionClicked(actionContext);

    }
    /**
     * Lance l'affichage de la da depuis le menu vertical de gauche.
     * @param dtoMenuObj
     */
    private showAssociatedviewOnVerticalMenuClick(dtoMenuObj: IIsiDtoMenuObject) {
        let associatedViewId = dtoMenuObj.key;
        let component = this._associatedViewsComponents[associatedViewId];
        if (component) {
            this._shownContextChangedByUser = true;
            if (uiCore.isRWDMobile) {
                window.scroll(0, 0)
            }
            this._updateDisplay(component, true, this._Refresh, false);
        }
    }
    /*
    * Méthode renvoyant la vue associée correspondant à l'id du control.
    */
    public getGridContextByComponentId(associatedViewId: string): Promise<IsiIWSAssociatedViewContext> {
        return new Promise((resolve, reject) => {
            this.getAssociatedViewByControlId(associatedViewId).then((component) => {
                resolve(component.context);
            })
        })
    }
    /*
    * Méthode renvoyant la vue associée correspondant à l'id du control.
    */
    public getAssociatedViewByControlId(associatedViewId: string): Promise<IsiIwsAssociatedView> {
        return new Promise((resolve, reject) => {
            if (Object.keys(this._associatedViewsComponents).length > 0) {
                resolve(this._associatedViewsComponents[Object.keys(this._associatedViewsComponents).find(key => this._associatedViewsComponents[key].serverId === associatedViewId)]);
            } else {
                // Si les données ne sont pas encore chargé, on s'abonne sur le chargement des DA.
                if (this._state) {
                    for (var i in this._state.states) {
                        let state = this._state.states[i];
                        uiCore.componentManager.whenComponentFound<IsiIwsAssociatedView>(state.gridViewId, (cp) => {
                            if (cp.serverId === associatedViewId) {
                                resolve(cp);
                            }
                        });
                    }
                }
            }
        })
    }
    /*
    * rend visible la DA ayant le controlId passé en paramètre.
    */
    public showAssociatedViewByControlId(associatedViewId: string, mode: string) {
        this.getAssociatedViewByControlId(associatedViewId).then((component: IsiIwsAssociatedView) => {
            if (component) {
                this._shownContextChangedByUser = true;
               this._updateDisplay(component, true, mode, false);
            }
        })
    }

    /*
    * rend visible la DA ayant le code écran passé en paramètre.
    */
    public showAssociatedViewByScreenCode(screenCode: string, mode: string) {
        const assCtxt = this.getAssContextFromScreenId(screenCode);
        if (assCtxt) {
            this.showAssociatedViewByControlId(assCtxt.gridViewId, mode);
        } else {
            uiCore.log(`La demande d'affichage de l'écran ${screenCode} a échouée aucun context correspondant trouvé.`);
        }
    }

    /**
     * Détermine si une donnée associée doit mettre à jour son lien maitre détail et le met à jour si nécessaire.
     * @param associatedViewContext
     */
    public async updatedJoinCtrls(associatedViewContext: IsiIWSAssociatedViewContext) {
        await this._xmlJoinManager.updateCtrlJoin(associatedViewContext);
    }

    private async _updateDisplay(component: IsiIwsAssociatedView, getUp: boolean, mode: string, updateOnInit: boolean) {
        if (updateOnInit) {
            isiApp.duplicateBench("Page", this._benchKeyGridFullLoad);
        } else {
            isiApp.startBench(this._benchKeyGridFullLoad);
        }

        let state: DetailState = DetailState.Down;
        const body = jQuery(document.body);

        if (this._currentComponent != null) {
            this._currentComponent.hide();
        }

        this._shownContext = component.context;

        if (getUp || !this.isUp()) {
            //Masque le formulaire et l'entete si on est en mode DA fixée
            if (body.hasClass("associatedViewFixed")) {
                screenCore.structure.divFormulaire.hide();
                screenCore.structure.divEntete.hide();
            }
            state = this.setHeight(uiCore.getClient().IsiDetH);

            body.addClass("associatedViewOpened");

            //Déplie le menu vertical lorsqu'on ouvre une DA
            const verticalMenuComp = uiCore.componentManager.getComponent<any>("associatedViewFormVerticalMenu");
            if (verticalMenuComp) {
                verticalMenuComp.isCollapsable = false;
                verticalMenuComp.unfold();
            }
        }

        // Focus sur la DA ou le formulaire
        this.setFocus(state);
        await this._xmlJoinManager.updateCtrlJoin(component.context);
        component.show();
        if (!component.isLoaded()) {
            component.runLoad();
        } else {
            switch (mode) {
                case this._Refresh:
                case this._None:
                    component.refresh();
                    break;
                case this._Reinit:
                    component.reinitGridData();
                    break;
            }
        }

        if (this._displayedAssociatedViewChanged) {
            this._displayedAssociatedViewChanged(this._state.states[this._shownContext.id].id)
        }
        this._currentComponent = component;
        this._state.shownContextId = this._shownContext.id;
        // Affichage de la barre dockée de la DA en mode tactile (non ouverte par défaut), sinon on affiche celle du formulaire.
        if (uiCore.isTouchMode()) {
            uiCore.showAssociatedViewDockedBar();
        }
        uiCore.showAssociatedViewBgm(this._shownContext.id)
        // gestion de l'autorefresh
        this._autoRefresh(component.context);

        if (uiCore.isTabularView()) {
            const tabularComponent = uiCore.componentManager.getComponent(component.context.gridViewId) as IsiIwsTabularView;
            if (uiCore.getCursorState() === CURSOR_STATE_UPDATE) {
                tabularComponent.setUpdateState();
            }

        }

    }

    /**
     * Activation de l'autorefresh
     * @param context
     */
    private _autoRefresh(context: IsiIWSAssociatedViewContext) {

        if (context.associatedViewState.autoRefresh) {
            const idMenu = context.id + MNU_DETAIL + MNU_SEP + DATA_MNUGRP_NAVIGATION + MNU_SEP + DATA_REFRESH;
            uiCore.RegisterAssociatedViewAutoRefresh(context, idMenu);
        }

    }

    get currentContext() {
        return this._shownContext;
    }

    private _associatedViewFound(associatedView: IsiIwsAssociatedView, associatedViewContext: IsiIWSAssociatedViewContext) {

        this._associatedViewsComponents[associatedViewContext.name] = associatedView;
        if (Object.keys(this._associatedViewsComponents).length > 1) {
            associatedView.hide();
        } else {
            this._currentComponent = associatedView;
        }
    }

    get currentComponent() {
        return this._currentComponent;
    }

    private _associatedViewInitialized(associatedViewCp: IsiIwsAssociatedView, associatedViewContext: IsiIWSAssociatedViewContext) {

        //ABON alors on demande au détail de s'abonner (retrait du this._associatedView)
        this.getInstanceOfAssociatedViewFromContext(associatedViewContext).then((associatedView) => {

            if (associatedViewContext.showCounter && uiCore.isTouchMode()) {

                this.associatedViewCountProvider.getCount(associatedViewContext, false, HandlerType.HMenu, (dto) => {
                    uiCore.componentManager.whenComponentReady<IsiHorizontalMenu>("associatedViewFormHorizontalMenu", (cp) => {
                        if (dto.nbRecord > 0)
                            cp.updateEntryLabelPostFix(associatedViewContext.associatedViewState.id, ` ${dto.badgeLabel}`);
                    })
                });
            }

            //On enregistre la donnée associée lorsqu'elle est initialisée pour ne pas la recréer si elle existe deja
            this._registerAssociatedView(associatedViewContext.id, associatedView);

            uiCore.gridDragNDropManager.observeGridDragNDrop(associatedViewCp)

            associatedViewCp.setColumnTemplateDlg((columnKey: string): IIsiDtoColumnTemplate => { return associatedView.getColumnTemplate(columnKey) });

            associatedViewCp.setColumnWidthDlg((column: IIsiDtoGridColumn): string => { return associatedView.getNewColumnWidth(column) });

            associatedViewCp.add_onToolbarClicked((sender, args) => {

                let actionContext = new IsiActionContext()
                actionContext.menu = screenCore.menuManager.getEntryById(args.id);
                actionContext.associatedViewContext = associatedViewContext;
                if (actionContext?.menu?.id === DATA_REFRESH) {
                    this._updateDisplay(associatedViewCp, true, this._Refresh, false);
                    actionContext.associatedViewContext.clearSelectedRows();
                    associatedView.changeValidationState(false);
                } else {
                    screenCore.uiActionClicked(actionContext);
                }

            });

            associatedViewCp.add_onRequestDataError((sender, args) => {
                this.close(associatedViewContext);
            });

            /**
             * Permet d'executer une action sur le double click
             */
            associatedViewCp.add_onRowDlbClicked((sender, args) => {
                let actionContext = new IsiActionContext()
                actionContext.menu = screenCore.menuManager.getEntryById(args.id);
                actionContext.associatedViewContext = associatedViewContext;
                if (associatedView.beforeRowDblClick(actionContext)) {
                    screenCore.uiActionClicked(actionContext);
                }

            });


            associatedViewCp.add_onCloseClicked((sender, args) => {
                let actionContext = new IsiActionContext()
                actionContext.menu = screenCore.menuManager.getEntryById(args.value);
                actionContext.associatedViewContext = associatedViewContext;
                screenCore.uiActionClicked(actionContext);
            });

            associatedViewCp.addCellUpdated((sender, args) => {
                associatedView.cellUpdated(args);
                //Si on a cliqué directement sur Enregistrer alors qu'on avait encore le focus dans l'editeur, on redéclenche l'édition
                if (this._btnValidateClick) {
                    this._btnValidateClick = false;
                    associatedViewCp.saveChanges(null, null, null);
                }
            });

            associatedViewCp.addEditorKeyDown((sender, args) => {
                associatedView.editorKeyDown(args);        
            });

            associatedViewCp.addEditCellEnded((sender, args) => {
                associatedView.editCellEnded(args);
            });

            associatedViewCp.addColumnResized((sender, args) => {
                associatedView.columnResized(args);
            });

            associatedViewCp.addColumnMoved((sender, args) => {
                associatedView.columnMoved(args);
            });
            associatedViewCp.addColumnSorted((sender, args) => {
                associatedView.columnSorted(args);
            });

            associatedViewCp.addGroupedColumnsChanged((sender, args) => {
                associatedView.groupedColumnsChanged(sender, args);
            });

            associatedViewCp.addGetMultiEditor((sender, args) => {
                associatedView.getMultiEditor(args);
            });

            associatedViewCp.addGetBranchDetail((sender, args) => {
                //Permet de récupérer la case à cocher "Détail de la branche"
                const checkBranch = jQuery("[id*='chkInfoBranch'][type='checkbox']");
                if (checkBranch.length === 1 && checkBranch.attr("checked") === "checked") {
                    args.branchDetailChecked = true;
                }
            });

            associatedViewCp.setSaveCustomBehaviour(new IsiIwsGridSavingBehaviour(associatedViewCp, associatedView));

            associatedViewCp.addBeforeSaveChanges((sender, args) => {

                if (associatedViewCp.getGridSaveMode() === SaveMode.Explicite) {
                    associatedView.changeValidationState(false);
                }

            });
            //Avant l'édition d'une ligne on peut décider de ne pas autoriser
            //la modification
            associatedViewCp.add_onRowEditStarting((sender, args) => {
                associatedView.rowEditStarting(args);
            });
            //Avant l'édition d'une cellule on peut décider de ne pas autoriser
            //la modification
            associatedViewCp.add_onCellEditStarting((sender, args) => {
                associatedView.cellEditStarting(args);
            });

            //Au début du click sur une cellule on peut décider d'annuler l'évènement.
            associatedViewCp.add_onCellClicking((sender, args) => {
                associatedViewContext.lastColumnClicked = args.columnKey;
                associatedViewContext.gridLevel = args.gridLevel;
                associatedView.cellClicking(args);
            });
            //Evenement levé à l'affichage d'une tooltip
            associatedViewCp.add_tooltipShowing((sender, args) => {
                associatedView.tooltipShowing(args);
            });

            //Evenement levé lors du chargement de données dans la da
            associatedViewCp.addOnDatabound((_sender, args) => {
                associatedView.databound(args);

                associatedViewCp.add_onRowsRendered(() => {
                    associatedView.rowsRendered();
                })

                this.associatedViewCountProvider.getCount(associatedViewContext, true, HandlerType.Da, (dto) => {
                    uiCore.gridManager.setCountNewGrid(dto.nbRecord, associatedViewContext.id, dto.nbPages);
                    this._gridCount = dto.nbRecord;

                    if (associatedViewCp.getDto().isPaginationEnabled) {
                        this._changeDockedBarSelectAllBtnLabel(associatedViewCp.getDto().chunkSize);
                    }
                });

                if (screenCore.isTabularView()) {
                    (uiCore.componentManager.getComponent(associatedViewContext.associatedViewState.gridViewId) as IsiIwsTabularView)?.editFiltersVisibility(true);
                }

                isiApp.stopAndRenderBench(this._benchKeyGridFullLoad);
            });

            associatedViewCp.addSelectedRowsChanged((sender, args) => {
                this.setFocus(DetailState.Up);
            })

            associatedViewCp.add_onPageChange(() => {
                isiApp.startBench(this._benchKeyGridFullLoad);
            });

            associatedViewCp.add_onLoadOnDemandStart(() => {
                isiApp.startBench(this._benchKeyGridFullLoad);
            });

            associatedViewCp.add_onLoadOnDemandCompleted((_sender, args: IIsiGridOnLoadOnDemandCompletedEventArgs) => {
                this._changeDockedBarSelectAllBtnLabel(args.newColumnCount);

                // Si toutes les lignes sont sélectionnées, on estime qu'on est sur un checkall, donc on veut sélectionner les prochaines 
                const rows = associatedViewCp.selectedRows?.rows;
                const gridElement = associatedViewCp._grid.get_element();
                if (!rows || !gridElement) return;

                const checkAndSelectRows = (): boolean => {
                    let allChecked = true;

                    rows.forEach(row => {
                        const elementParent = document.querySelector(`[data-id="${row.key}"]`) as HTMLElement;
                        if (!elementParent) return;

                        // sélection de l’élément selon le mode mobile RWD ou non car on n’a pas la même structure 
                        const element = (uiCore.isRWDPhone()
                            ? document.querySelector(`[data-row-key-value="${row.key}"]`)
                            : elementParent.querySelector('[data-role="checkbox"]')) as HTMLElement;
                        if (!element) return;

                        // sélection des sous-éléments selon le type
                        const checkbox = element.querySelector('.IsiCheckBox input') as HTMLInputElement;
                        const iconCheck = element.querySelector('.ui-icon-check') as HTMLElement;

                        // on vérifie si la ligne est déjà cochée
                        const isChecked = (checkbox?.checked ?? iconCheck?.classList.contains('ui-igcheckbox-normal-on')) ?? false;

                        //  Si non cochée → coche et sélectionne
                        if (!isChecked) {
                            if (checkbox) {
                                checkbox.checked = true;
                            } else if (iconCheck) {
                                iconCheck.classList.add('ui-igcheckbox-normal-on');
                            }
                            associatedViewCp.selectRowByPk(row.key);
                        } else if (!checkbox && !iconCheck) {
                            allChecked = false;
                        }
                    });
                    return allChecked;
                };

                // On ne fait le checkUncheckAll que si toutes les anciennes lignes étaient déjà sélectionnées
                if (args.previousColumnCount === rows.length) {
                    associatedViewCp._grid.checkUncheckAll({
                        grid: { dataSource: associatedViewCp._grid._dataSource },
                        newState: "on"
                    });
                    checkAndSelectRows();
                }

                // On crée un observer pour les nouvelles checkboxes créées On-Demand
                const observer = new MutationObserver((mutations, obs) => {
                    if (checkAndSelectRows()) {
                        obs.disconnect();
                    }
                });

                observer.observe(gridElement, { childList: true, subtree: true });

                isiApp.stopAndRenderBench(this._benchKeyGridFullLoad);
            });

            // gestion de l'affichage
            this._updateDisplayOnInit(associatedViewCp, associatedViewContext);
            window.addEventListener("beforeunload", () => {
                associatedViewCp.abortLoadingRequest();
                uiCore.gridManager.abortAllAjaxRequest();
            })

            associatedViewCp.add_onRowDragStart((_sender, args: IIsiGridRowDragStartArgs) => {
                associatedView.rowDragStart(args)
            })
        });

    }

    private _cellDoubleClicked(context: IsiIWSAssociatedViewContext, cellId: string): Promise<boolean> {
        if (this.cellDoubleClickedOverridable(context, cellId)) {
            return new Promise<boolean>((resolve, reject) => {
                this.getInstanceOfAssociatedViewFromContext(context).then((associatedView) => {
                    resolve(associatedView.cellDoubleClicked(cellId));
                }).catch((e) => {
                    reject();
                });
            });
        }
    }

    protected cellDoubleClickedOverridable(context: IsiIWSAssociatedViewContext, cellId: string) {
        return true;
    }

    get mainContext() {
        return this._shownContext;
    }

    get exist() {
        return this._exist;
    }

    get hasFocus() {
        return this._hasFocus;
    }

    set hasFocus(value: boolean) {
        this._hasFocus = value;
    }

    get lastDragTopPostion() {
        return this._lastDragTopPostion;
    }

    set lastDragTopPostion(value: number) {
        this._lastDragTopPostion = value;
    }

    //Création d'un événement sur le grip de la DA afin de savoir lorqu'il est utilisé
    get onGripMouseUpHandlers(): ((sender: IsiDetailManager) => void)[] {
        this._onGripMouseUpHandlers = this._onGripMouseUpHandlers || [];
        return this._onGripMouseUpHandlers;
    }
    /***
     * Retourne le context d'une donnée associée par rapport au code écran
     * 
     */
    getAssContextFromScreenId(id: string) {
        return this.getContext("AssociatedView" + id)
    }

    getContext(id: string): IsiIWSAssociatedViewContext {
        return <IsiIWSAssociatedViewContext>screenCore.gridManager.getContext(id);
    }

    //---------------------------------------------------------------
    // Private members
    //---------------------------------------------------------------
    getInnerDetail() {
        //ABON suivant le context on instancie un detail différent.
        if (this._detail == null) {
            if ((uiCore.isRWD() && uiCore.isTouchMode())) {
                this._detail = new IsiDetailRWD();
            }
            else {
                this._detail = new IsiDetailVintage();
            }
        }
        return this._detail;
    }
    //---------------------------------------------------------------
    // Public members
    //---------------------------------------------------------------
    getHeader() {
        return uiCore.componentManager.getComponent<any>(this.getInnerDetail().getHeaderComponentId());
    }

    whenHeaderFound(handler) {
        uiCore.componentManager.whenComponentFound(this.getInnerDetail().getHeaderComponentId(), handler);
    }

    getHeaderComponentId() {
    }

    saveState() {
        //  <summary>
        //  Sauve l'etat de l'objet a envoyer au serveur. Il sera charge cote serveur par IsiClientState.IsiLoad.
        //  </summary>

        isiApp.appState.detailState = this._state;
        isiApp.appState.detailUpDemanded = this._upDemanded;
        isiApp.appState.detailCloseDemanded = this._closeDemanded;
    }

    heightIsOk() {
        ///<summary>Vérifie que la hauteur de la partie detail reste dans des limites raisonnables</summary>             

        // IsiDetH contient la hauteur de la DA, donc plus IsiDetH est grand, plus la DA est haute et plus elle couvre l'écran
        const screenHeight = isiApp.dtoClientIWS.IsiHeight.value;
        const detailHeight = isiApp.dtoClientIWS.IsiDetH;

        if (isiApp.screen.pageName === 'LIST002') {
            // sur une requête : ne pas mémoriser si la hauteur de DA est inférieure à 22% de la hauteur d'écran, 
            // par contre cela peut être pertinent sur une requête de la positionner haut
            if (detailHeight < (22 * screenHeight) / 100) {
                return false;
            }
        } else {
            // 1-sur une DA : ne pas mémoriser si la hauteur de DA est inférieure à 22% de la hauteur d'écran 
            // ni si elle est supérieure à 70%
            if (detailHeight > (70 * screenHeight) / 100) {
                return false;
            } else if (detailHeight < (22 * screenHeight) / 100) {
                return false;
            }
        }
        return true;
    }

    loadState() {
        //  <summary>Charge l'etat de l'objet en provenance du serveur.</summary>
    }

    _ensureInitialized() {
        if (!this._initialized) {
            this._init();
        }
    }

    _init() {
        // <summary>
        //  Initialise le manager pour la zone de detail.
        //  Le manager existe toujours contrairement au detail.
        //  Attention, ceci n'a rien a voir avec la grille !
        // </summary>
        this._exist = true;

        if (!(uiCore.isRWD() && uiCore.isTouchMode()) && iws_GetPageName() != "LIST002") {
            screenCore.structure.divDetailGrip.on("mousedown", function (me) {
                return function () {
                    me.onGripMouseDown(event);
                }
            }(this));
        }

        this.afterInit();

        this._initialized = true;

        this._ensureMaxHeight();
        //uiCore.log("detail-init");               
    }

    private _updateDisplayOnInit(associatedViewCp: IsiIwsAssociatedView, associatedViewContext: IsiIWSAssociatedViewContext) {

        //a l'init d'un écran, affiche la DA courante s'il y'en a une (dans le cas où l'on revient sur l'écran principal après avoir été sur le formulaire d'une DA par exemp)
        if (this._state.shownContextId === associatedViewContext.id) {
            this._updateDisplay(associatedViewCp, (this._state.displayDetailImplicitely || this._state.associatedViewPosition == DetailState.Up),this._None, true);
        }
    }

    setAfterInit(func) {
        this.afterInit = func;

        if (this._initialized) {
            this.afterInit();
        }
    }

    afterInit() {
        //Fonction a surcharger        
        return true;
    }

    initDivs() {
        return isiApp.display.initDivs();
    }

    //private _notAllowed(active: boolean) {
    //    if (active) {
    //        // //screenCore.structure.divDetailGrip.css("cursor", "not-allowed");
    //        // jQuery('#DivWrapperPage').addClass('not-allowed');
    //        jQuery('#DivDetailGrip').css('cursor', 'not-allowed');
    //        jQuery('#DivRight').css('cursor', 'not-allowed');
    //    } else {
    //        // //screenCore.structure.divDetailGrip.css("cursor", "");       
    //        //  jQuery('#DivWrapperPage').removeClass('not-allowed');
    //        jQuery('#DivDetailGrip').css('cursor', '');
    //        jQuery('#DivRight').css('cursor', '');
    //    }
    //}

    //private _rowResize(active: boolean) {
    //    if (active) {
    //        // //screenCore.structure.divDetail.addClass("dragging");
    //        // jQuery('#DivWrapperPage').addClass('row-resize');
    //        jQuery('#DivDetailGrip').css('cursor', 'row-resize');
    //        jQuery('#DivRight').css('cursor', 'row-resize');
    //    } else {
    //        //   //screenCore.structure.divDetail.removeClass("dragging");
    //        // jQuery('#DivWrapperPage').removeClass('row-resize');
    //        jQuery('#DivDetailGrip').css('cursor', '');
    //        jQuery('#DivRight').css('cursor', '');
    //    }
    //}

    onGripMouseDown(event) {

        //On stock la hauteur dans une seconde variable pour le double click
        if (!isiApp.dtoClientIWS.IsiHeightOnClick) {
            isiApp.dtoClientIWS.IsiHeightOnClick = isiApp.dtoClientIWS.IsiDetH;
        }
        //this._rowResize(true);
        this._splitterDetail.offsetTop = screenCore.structure.divDetailGrip.offsetTopAsInt();
        this._splitterDetail.top = screenCore.structure.divDetailGrip.topAsInt();

        document.onmousemove = function (me) {
            return function (event) {
                me.onGripMouseMove(event);
            }
        }(this);

        document.onmouseup = function (me) {
            return function () {
                me.onGripMouseUp();
            }
        }(this);

        document.onselectstart = function () {
            return false;
        };

        jQuery(".IsiGrid.IsiIwsGrid").hide();

        this._lastDragTopPostion = -1;

        const state: DetailState = this.changeState(DetailState.Up);
        this.setFocus(state);
    }

    onGripMouseUp() {

        document.onmousemove = null;
        document.onmouseup = null;
        document.onselectstart = null;

        jQuery(".IsiGrid.IsiIwsGrid").fadeIn(500);

        // Si la hauteur de la grille est plus grand que la hauteur de son en tête, on mémorise cette hauteur pour la restaurer au double click.
        if (isiApp.dtoClientIWS.IsiDetH > jQuery(".associatedViewHeader").height() + screenCore.structure.divDetailGrip.height()) {
            isiApp.dtoClientIWS.IsiHeightOnClick = isiApp.dtoClientIWS.IsiDetH;
        }

        isiApp.display.refresh();
        this._lastDragTopPostion = -1;
        this._saveState();
        this._onGridMouseUp();
    }

    // LFEN - Ajout d'un événemment sur le GripMouseUp 
    add_onGripMouseUp(handler: (sender: IsiDetailManager) => void) {
        this.onGripMouseUpHandlers.push(handler);
    }

    _onGridMouseUp() {
        for (const value of this.onGripMouseUpHandlers) {
            value.call(this, this);
        }
    }

    onGripMouseMove(event) {
        // <summary>
        //  Evenement appele pendant que le grip est deplace.
        // </summary>

        // Ici, on calcul la nouvelle hauteur que doit prendre la zone de la grille.
        // Pour cela, on va calculer la hauteur de tout ce qui n'est pas la zone de la grille et la soustraire
        // à la hauteur total du formulaire, corrigé du déplacement de la souris.
        // cf. wit:48180 et sa fameuse copie d'écran !

        // décalage du parent de la zone de la grille par rapport au haut du formulaire
        const parentElements = jQuery('#DivRight');
        let deltaParent = 0;
        if (parentElements.length > 0) {
            deltaParent = parentElements.offsetTopAsInt();
        }


        // décalage de la barre d'action
        const actionBarElements = jQuery('.IsiButtonBarDetail');
        let deltaActionBar = 0
        if (actionBarElements.length > 0) {
            deltaActionBar = actionBarElements.heightAsInt();
        }

        // calcul le nombre de pixel dont on essaye de déplacer le grip
        let ecartDeMvt = event.clientY - this._splitterDetail.offsetTop;

        // ici, _splitterDetail.top + deltaParent correspond à la hauteur entre le haut de l'écran et le haut de la zone de la grille
        let moveY = this._splitterDetail.top + deltaParent + deltaActionBar + ecartDeMvt;

        //uiCore.log("detail-_dragging debut");
        this._draggingInProgress = true;

        //Perf stockage des informations de drag n drop pour n'utiliser que la differentielle
        if (this._limitSizes(isiApp.dtoClientIWS.IsiHeight.value - moveY)) {

            // si on depasse la zone alors on change le curseur et on replace le grip dans la zone possible
            //this._notAllowed(true);
            moveY = isiApp.dtoClientIWS.IsiHeight.value - this._gripHeight - isiApp.dtoClientIWS.IsiDetH;

        }// else {
        //this._notAllowed(false);

        // }

        // on ne redimentionne que si un deplacement en hauteur est enregistre
        if (moveY != this._lastDragTopPostion) {
            this._ensureAssociatedViewHeight();
        }
        this._draggingInProgress = false;

        //uiCore.log("detail-_dragging fin");
    }

    isUp() {
        // <summary>
        //  Indique si le detail est affiche.
        // </summary>
        return (this._exist && this._state.associatedViewPosition == DetailState.Up);
    }

    isDown() {
        // <summary>
        //  Indique si le detail est masqué.
        // </summary>
        return (this._exist && this._state.associatedViewPosition == DetailState.Down);
    }

    isDragging() {
        // <summary>
        //  Indique si le detail est en train d'etre redimensionne par l'utilisateur.
        // </summary>
        return (this._exist && this._draggingInProgress);
    }

    ready() {
        // <summary>
        // Appelee lorsque l'application est chargee.
        // </summary>      
    }

    hide() {
        // <summary>
        // Cache la zone de detail.
        // </summary>

        if (!this._exist || !this.initDivs()) { return; }

        const state: DetailState = this.changeState(DetailState.Down);
        this.setFocus(state);
        this.refresh();
        isiApp.display.refresh();
        modifWaitStatus(false, false, "");
    }

    close(viewContext?: IsiIWSAssociatedViewContext): Promise<IIsiUIFlowResult> {
        // <summary>
        // Ferme la zone de detail.
        // </summary>
        return new Promise((resolve, reject) => {
            if (!this._exist || !this.initDivs()) { return; }

            jQuery(document.body).removeClass("associatedViewOpened");

            // on ferme le menu de la grille (DA ou tabularView)
            if (viewContext && viewContext.gridViewId) {
                (uiCore.componentManager.getComponent(viewContext.gridViewId) as IsiGridView).closeBurger();
            }

            this.removeSelectedAssociateView();

            this._state.shownContextId = '';
            this._shownContext = null;
            this._shownContextChangedByUser = true;
            this._state.associatedViewPosition = DetailState.Down;

            // on rafraichit l'affichage
            isiApp.display.refresh();

            //Rend visible le formulaire et l'entete dans le cas ou ils étaient masqués
            screenCore.structure.divFormulaire.show();
            screenCore.structure.divEntete.show();

            // on met le focus sur le formulaire
            // CLEM - On change l'affichage des barres d'action
            isiApp.focus.onForm();

            // on vide le champ de recherche lorsque l'on ferme la DA.
            jQuery("#gf_sr").val('');

            let submit: boolean = false;

            if (viewContext) {
                submit = viewContext.associatedViewState.searchType === IsiSearchType.FormSearch;
            }

            resolve({ continue: submit, result: true });
        })
    }

    showNextSubmit() {
        // <summary>
        //  Demande au detail de s'afficher lors du prochain repostage.
        // </summary>
        this._upDemanded = true;
    }

    displayByCtrl() {
        // <summary>
        // Indique que l'affichage d'un detail est demande par un controle (ex : vue doublons sur incident)
        // </summary>
        this._displayViewByCtrl = true;
    }

    changeState(newState?: DetailState): DetailState {
        // <summary>
        // Modifie l'etat de la zone detail. 
        // </summary>
        // <param name="newState" type="DetailPosition">Nouvelle position.</param>
        let calculatedState: DetailState;
        if (!this._exist) { return DetailState.None; }

        // determination du nouvel etat.
        if (newState === null || typeof (newState) == "undefined") {
            // lors d'un appel a la fonction sans parametre,
            // on prend l'etat stocke et on va afficher son contraire
            if (this._state.associatedViewPosition == DetailState.Down) {
                this._state.associatedViewPosition = DetailState.Up;
                calculatedState = DetailState.Up;
            } else {
                this._state.associatedViewPosition = DetailState.Down;
                calculatedState = DetailState.Down;
            }
        } else {
            this._state.associatedViewPosition = newState;
            // msie a jour du dto
            if (newState == DetailState.Down || !this.mainContext) {
                calculatedState = DetailState.Down;
            }
            else {
                calculatedState = DetailState.Up;
            }
        }

        return calculatedState;
    }

    setFocus(state: DetailState) {
        // <summary>
        // Applique réellement le focus.
        // </summary>  
        if (state == DetailState.Down || !this._state.focusOnDetail) {
            isiApp.focus.onForm();
            this._state.focusOnDetail = true;
        } else if (state == DetailState.Up) {
            isiApp.focus.onDetail();
        }

    }

    canFocusDetail(): DetailState {
        // <summary>
        // Vérifie que la zone de detail peux recevoir le focus.
        // </summary>  

        let state: DetailState = DetailState.Up;

        if (isiApp.dtoClientIWS) {
            //Affecte le focus sur le formulaire si la DA affichée est la DA par défaut
            //GBAU - 30/07/2019 : Dans le cas de la VT, si on affiche la DA (VT rafrachie, recherche formulaire), on laisse le focus sur la DA

            // ici il faut laisser Up si on vient de cliquer sur un menu, ou qu'on est sur la VT ou qu'on revient d'une association

            if (!uiCore.isTouchMode() && !screenCore.isTabularView()) {
                if (this.currentContext && (!this._state.isDefaultView || this._shownContextChangedByUser)) {
                    state = DetailState.Up;
                } else {
                    if (isiApp.display._divMainContent && !uiCore.isTouchMode()) {
                        state = DetailState.Down;
                    }
                }
            }
        }
        return state;
    }

    show() {
        // <summary>
        // Affiche la zone de detail par rapport a son etat.
        // </summary>     

        this._gripHeight = screenCore.structure.divDetailGrip.heightAsInt();

        // si on a pas de dto client ou que l'on a pas ete redientionne par le serveur
        if (!isiApp.dtoClientIWS || isiApp.dtoClientIWS.IsiResizedState != 1) {
            isiApp.display.refresh();
        } else // on init les abonnements au drag de la partie detail
        // ainsi que les menus
        {
            this.initDivs();
            this.loadAssociatedView();
        }

        uiCore.disableWaitIfNeeded();

    }

    doubleClick() {
        /// <summary>
        ///  Gere le double click sur le grip de la zone detail.
        /// </summary>

        let state: DetailState;

        this._doubleClicked = true;

        if (isiApp.dtoClientIWS) {
            isiApp.dtoClientIWS.IsiResizedState = 0;
        }
        //Si la grille est plus grande que son en tête on change son état, sinon on ne le fait pas pour que le déploiement de la grille se fasse quand même.
        if (isiApp.dtoClientIWS.IsiDetH > jQuery(".associatedViewHeader").height() + screenCore.structure.divDetailGrip.height()) {
            state = this.changeState();
        }

        this.show();
        this.setFocus(state);

    }

    dispose() {
        // <summary>
        //  Liberation de la memoire utilise par la zone de detail.
        // </summary>
        this._ajax = null;
    }

    refresh(resize = false) {
        /// <summary>
        /// Modifie les elements HTML utilises pour la zone de detail.
        /// </summary>

        if (!this._exist || !this.initDivs()) { return; }

        //uiCore.log("detail-refresh debut");

        this._ensureMaxHeight();

        this._setInnerElementsVisible();

        this._ensureAssociatedViewHeight(resize);

        if (this._state.associatedViewPosition == DetailState.Up) {
            // Nous mettons le focus APRES les traitements, pour etre sûr que l'objet est
            // bien visible et affiche en bloc. (cf. majHiddendivDetail)
            isiFocusMe(screenCore.structure.divDetail.get(0));
        }

        //uiCore.log("detail-refresh fin");
    }

    _ensureMaxHeight() {
        // On retire 6px à la hauteur maximale. 6px est la hauteur qui dépasse du bouton grip de l'en-tête de la grille.
        if (jQuery("#DivEntete").exists()) {
            this._maxHeight = jQuery(document.body).height() - (jQuery("#DivEntete").offsetTopAsInt() + jQuery("#DivEntete").height() + 6) - screenCore.dockedBarHeight();
        } else {
            this._maxHeight = jQuery(document.body).height() - (jQuery("#DivFormulaire").offsetTopAsInt() + 6) - screenCore.dockedBarHeight();
        }
    }

    setHeight(height: number): DetailState {

        let state: DetailState = DetailState.None;
        let orignalState: DetailState = this._state.associatedViewPosition;

        //GBAU - 13/08/2012 - DEV52307
        //Permet de setter la hauteur. Si déjà initialisé, on redemande le show
        if (isiApp.dtoClientIWS) {
            isiApp.dtoClientIWS.IsiDetH = Math.max(0, height);
            isiApp.dtoClientIWS.IsiResizedState = 0;
        }

        this._state.associatedViewPosition = DetailState.Up;
        state = this.changeState(DetailState.Up);
        if (this._initialized) {
            this.show();
        }

        // si la DA est la VT, ou une vue par défaut, ou un retour d'association, le focus peut être mis ou non
        if (state == DetailState.Up && (orignalState == DetailState.Up || this.canFocusDetail() == DetailState.Up)) {
            state = DetailState.Up;
        } else {
            state = DetailState.Down;
        }

        //TCLE : On récupère la hauteur du grip ici pour être sur de l'avoir mais si on fait pas le this.show()
        this._gripHeight = screenCore.structure.divDetailGrip.heightAsInt();

        // ABON :il faut rafraichir l'ihm 54508
        isiApp.display.refresh();

        if (isiApp.dtoClientIWS) {
            isiApp.dtoClientIWS.IsiResizedState = 1;
        }

        return state;
    }

    //---------------------------------------------------------------
    // Private members
    //---------------------------------------------------------------
    _setInnerElementsVisible() {
        // <summary>
        // Rend visible les elements de la zone de detail.
        // </summary>
        // <history>
        //     <entry mat="YBRU" date="12/05/2017" task="1021416">Gestion de la classe qui permet de savoir si une DA est a le focus</entry>
        // </history>

        this.initDivs();

        if ((uiCore.isRWD() && uiCore.isTouchMode())) {
            if (this._state.associatedViewPosition == DetailState.Up) {
                screenCore.showAssociatedView();
            }
        }
    }

    _limitSizes(height) {
        // <summary>
        // Verifie et reduit si necessaire la hauteur de la zone de detail et la position du grip.
        // </summary>

        let newHeight = Math.min(Math.max(height, this._gripHeight), this._maxHeight);
        let isLimited = height != newHeight;

        // mise à jour du dto
        isiApp.updateDtoClientIWSDetailInfoOnDrag(newHeight);

        return isLimited;
    }

    _ensureAssociatedViewHeight(force = false) {
        if ((uiCore.isRWD() && uiCore.isTouchMode())) {
            return;
        }

        if (this._state.associatedViewPosition === DetailState.Up) {
            this._ensureDetailUpHeight(force);

            //Si on vient de faire un double click sur le grip, il faut réduire la DA
        } else if (force || !this._draggingInProgress) {
            this._setDivDetailHeight(this._gripHeight);
        }

        if (this._doubleClicked) {
            this._doubleClicked = false;
        }
    }

    _ensureDetailUpHeight(force = false) {

        if (this._doubleClicked || force || this._draggingInProgress || (!this._draggingInProgress && this._limitSizes(isiApp.dtoClientIWS.IsiDetH))) {
            //Dans le cas d'un double click pour déployer la DA, on utilise la hauteur stockée à la fin du dernier redimenssionement.
            if (this._doubleClicked && !this._limitSizes(isiApp.dtoClientIWS.IsiHeightOnClick)) {
                this._setDivDetailHeight(isiApp.dtoClientIWS.IsiHeightOnClick);
            } else {
                this._setDivDetailHeight(isiApp.dtoClientIWS.IsiDetH);
            }
        }
    }

    /**
     * Applique la hauteur au DivDetail
     * @param height
     */
    _setDivDetailHeight(height: number) {
        if (!jQuery("BODY").hasClass("associatedViewFixed")) {
            screenCore.structure.divDetail.height(height);
        }
    }

    /*
     * Modifie le label du bouton "Tout sélectionner" pour lui ajouter/modifier le count de la grille entre parenthèses
     */
    private _changeDockedBarSelectAllBtnLabel(displayColumnsCount: number) {
        const button = jQuery("input.iButton[name*='DATA_SELECTALL_ITEM']")

        if (button.length) {
            let buttonLabel = button.val().toString();
            if (displayColumnsCount < this._gridCount && displayColumnsCount !== 0) {
                // Regex qui vise à sélectionner le bout de texte ou il y a marqué le count de la grille dans le bouton "Tout sélectionner"
                // "Tout sélectionner (100)", avec la regex on obtiendra "(100)"
                const regexForParenthesis = /\((\d+)\)(?!.*\(\d+\))/

                if (regexForParenthesis.test(buttonLabel)) {
                    buttonLabel = buttonLabel.replace(regexForParenthesis, `(${displayColumnsCount})`);
                } else {
                    buttonLabel += ` (${displayColumnsCount})`;
                }

                button.val(buttonLabel);
            } else {
                // Le nb d'élements affichés sont >= au count de la grille ou alors égal à 0, donc le label devient uniquement "Tout sélectionner" (sans les parenthèses)
                button.val(buttonLabel.replace(/\s*\(\d+\)/, ""))
            }
            
        }
    }

    _saveState() {
        ///  <summary>
        ///  Sauve l'etat de detail a envoyer au serveur. Il sera charge cote serveur par IsiClientState.IsiLoad.
        ///  </summary>

        if (this.heightIsOk()) {

            // LBRI - 2012.09.27 - [DYSF:52389] : duplication des paramètres de position du grip, pour la LIST002
            var dataToSend = "Traitement=IsiAsyncDetail&TYPE=SaveState&PosVerti=" + encodeURIComponent(isiApp.dtoClientIWS.IsiDetH) + "&PageName=" + encodeURIComponent(isiApp.screen.pageName);
            this._ajax = new IsiJavaScriptAjax("../../Classes/IsiAjax/IsiAjax.aspx");
            this._ajax.init();
            this._ajax.AsyncExecute(dataToSend, "POST", true, "TEXT", "TEXT"); 
        }
    }

    removeSelectedAssociateView() {
        jQuery(".selected", jQuery("#associatedViewFormVerticalMenu")).removeClass("selected");
    }

    loadAssociatedView() {
        this._ensureAssociatedViewHeight(true);
    }

    // ORIC - 060509 - [DEV] : Avant de lancer l'action cote serveur, cette fonction verifie si
    // la grille contient des enregistrements de coches. Ce test est lance :
    //		- Si on clique sur le menu de la vue associee,
    //		- Si le menu est un traitement OU une navigation specifique (SUPPRIMER, DUPLIQUER...)
    // SDEN - MODIFICATION : Il n'y pas besoin d'avoir un enreg de selectionne pour executer 
    //					     les actions Tout autoriser et Tout Interdire
    // ORIC - 060707 - [DYSF 14189] : Si on fait "Propriete" sur les pieces jointes, le test n'est pas 
    //								  effectue.
    // OMOU - 061107 - [DYSF 15838] : on lance aussi le test pour l'action 'Lier comme pere' qui se
    //								  situe sur la vue associee Incidents en double. (Si l'utilisateur 
    //								  clique sur l'action 'Lier comme pere' sans avoir selectionne 
    //								  un incident dans le tableau, le message s'affiche).
    // LBRI - 2007.04.02 - [DYSF:16827] : on n'effectue pas le test si un drag'n drop est en cours.
    // YPIV - 13/08/2007 - DEV 13164 : On a pas besoin d'avoir un enregistrement selectionner pour l'action VoirCatalogueMarchand.
    // CEGO - 2010.02.18 - [DYSF:34031] : On enleve le cas particulier des pieces jointes (gere en amont dans la fonction iws_SpecifActionItem()),
    // de l'action lier comme pere, imprimer etiquette et avancement workflow qui ne servaient a rien.
    // RGEL - 2011.05.18 - DEV 43751 -  Ajout des action Marquer/Demarquer
    // DGRA - 24/01/2012 - DYSF47330 - Ajout des actions UP, DOWN, BOTTOM et TOP
    // CDES - 27/12/2016 - T128325 - On ne vérifie pas s'il y a des enregistrements sélectionnés pour l'action "Créer BR" (PARC013LCOMMANDE)
    // CDES - 02/01/2017 - T128326 - On ne vérifie pas s'il y a des enregistrements sélectionnés pour l'action "Créer Facture" (PARC027LCOMMANDE)
    public beforeActionOnDetail(flow: IIsiUIFlowResult, actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            let item = actionContext.uiAction;

            if ((item.key === DISSOCIATEv2
                || item.key === DUPLICATEv2
                || item.key === DATA_DELETEv2
                || item.key === DATA_ARCHIVE_ONv2
                || item.key === DATA_RESTOREv2
                || item.key === FILLREPLACEv2
                || item.key === DATA_PROPERTYv2 //GBAU - 03/07/2012 - DEV52305 - Rajout du message lorsque l'on fait propriété
                || item.key === MenuItemCode.BOTTOM
                || item.key === MenuItemCode.UP
                || item.key === MenuItemCode.DOWN
                || item.key === MenuItemCode.TOP
                || (item.key === MARK_ITEM)
                || (item.key === UNMARK_ITEM)
                || (item.key === DATA_MARK_ITEM)
                || (item.key === DATA_UNMARK_ITEM)
                || (item.key === MenuItemCode.SELECT)
                || (item.key.substr(0, 6) === "action")
                && (item.key !== "actionMAJParam")
                && (item.key !== "actionToutAutoriser")
                && (item.key !== "actionToutInterdire")
                && (item.key !== "actionVoirCatalogueMarchand")
                && (item.key !== "actionMajOrdreCaracFromTyp")
                && (item.key !== "actionAddCaracOnRef")
                && (item.key !== "actionMajOrdreCaracFromRef")
                && (item.key !== "actionMajCaracOnObj")
                && (item.key !== "actionGenererObjets")
                && (item.key !== "actionSynchroCarac")
                && (item.key !== "actionPropagateAccessRights")
                && (item.key !== "actionAddBR")
                && (item.key !== "actionPeuplerCouleurs")
                && (item.key !== "actionViderCouleurs")
                && (item.key !== "actionAddFacture")
                && (item.key !== "actionToutCreer")
                && (item.key !== "actionToutRapprocher")
                && (item.key !== "actionActualisePlanPrev")
                && (item.key !== "actionSynchroPopu")
                && (item.key !== "actionSynchroPopuPlanning")
                && (item.key !== "actionImportObjetSql"))
                // LBRI - 2007.04.02 - [DYSF:16827] : on test si un drag'n drop ne serait pas en cours.
                // si c'est le cas, il n'est pas besoin de faire le test.
                && (window.gbDragDropInProgress !== true
                    && !screenCore.gridManager.checkDetailGridValidity(actionContext.associatedViewContext))) {

                uiCore.showErrorMessage(uiCore.getMessage("Err", "Grid_NoSelection").IsiLabel, { iconType: IsiIconType.UserError });
                flow.continue = false;
                reject("Grid_NoSelection");
            }
            // CLEM - PopIn - 118175
            if (flow.continue) {
                screenCore.beforeActionOnDetail(actionContext);
                this._beforeAction(actionContext).then(() => {
                    if (actionContext.beforeActionOnDetail) {
                        this.getInstanceOfAssociatedViewFromContext(actionContext.associatedViewContext).then((associatedView) => {
                            associatedView.beforeActionOnDetail(actionContext).then((beforeActionOnDetailResult) => {
                                // en cas d'annulation de l'action, on désélectionne tout
                                if (!beforeActionOnDetailResult.continue) {
                                    actionContext.associatedViewContext.clearSelectedRows();
                                }
                                resolve(beforeActionOnDetailResult);
                            });
                        });
                    }
                });
            }
        });
    }

    private _beforeAction(actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return this.beforeActionOverridable(actionContext);
    }

    protected beforeActionOverridable(actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return new Promise<IIsiUIFlowResult>((resolve, reject) => {
            resolve({ result: true, continue: true });
        });
    }

    getInstanceOfAssociatedViewFromContext(associatedViewContext: IsiIWSAssociatedViewContext): Promise<IsiIWSAssociatedView> {
        if (associatedViewContext == null) return;

        return new Promise<IsiIWSAssociatedView>((resolve, reject) => {
            if (this._associatedViews[associatedViewContext.id]) {
                resolve(this._associatedViews[associatedViewContext.id]);
            } else {
                resolve(this.createInstanceOfAssociatedView(associatedViewContext));
            }
        })
    }

    getAssociatedViewFromContextId(contextId: string): IsiIWSAssociatedView {
        return this._associatedViews[contextId];
    }

    createInstanceOfAssociatedView(associatedViewContext: IsiIWSAssociatedViewContext): Promise<IsiIWSAssociatedView> {
        if (associatedViewContext.associatedViewState.useTS) {
            return new Promise<IsiIWSAssociatedView>((resolve, reject) => {
                let scriptName: string;
                if (associatedViewContext.scriptNameForTs !== null && associatedViewContext.scriptNameForTs !== "") {
                    scriptName = associatedViewContext.scriptNameForTs;

                } else {
                    scriptName = associatedViewContext.name;
                }
                import(
                    /* webpackChunkName: "Business/AssociatedViews/[request]" */
                    `./../../../Business/AssociatedViews/${scriptName}.ts`
                ).then((module) => {
                    let o: any;
                    try {
                        o = new module[scriptName](associatedViewContext);
                    } catch (ex) {
                        uiCore.log('createInstanceOfAssociatedView erreur lors de la création du détail ' + associatedViewContext.name + ', : ' + ex.message);
                    }
                    if (o) {
                        resolve(o);
                    } else {
                        resolve(new IsiIWSAssociatedView(associatedViewContext))
                    }
                }).catch((e) => {
                    console.log(e);
                });;
            });
        } else {
            return new Promise<IsiIWSAssociatedView>((resolve, reject) => {
                if (typeof (window[associatedViewContext.name]) == "function") {
                    resolve(new (window[associatedViewContext.name])(associatedViewContext));
                } else {
                    resolve(new IsiIWSAssociatedView(associatedViewContext));
                }
            });
        }

        return null;
    }

    /**
     * Permet d'enregistrer une donnée associée lorsqu'elle est initialisée
     * @param assId
     * @param associatedView
     */
    private _registerAssociatedView(assId: string, associatedView: IsiIWSAssociatedView) {
        this._associatedViews[assId] = associatedView;
    }

    _createInstanceOfEmptyAssociatedViewContext() {
        return new IsiIWSAssociatedViewContext(uiCore.componentManager, "", IsiDtoIwsAssociatedViewClientState.fromJS({ useTS: false }));
    }

    uiActionClicked(flow: IIsiUIFlowResult, actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            // if (item.menuGroupId.substr(0, CstDATA.length) === CstDATA) {
            actionContext.associatedViewContext = actionContext.associatedViewContext || this.currentContext || this.mainContext || this._createInstanceOfEmptyAssociatedViewContext();
            //On set le context de l'action courrante notamment pour setter l'information sur l'openArgs d'une popin plutard.
            //Attention pas d'accès public interdit! 
            uiCore.setCurrentActionContext(actionContext);

            this.beforeActionOnDetail(flow, actionContext).then((result) => {
                if (result.continue === true) {
                    this._actionGrid(actionContext).then((actionGridResult) => {
                        if (actionGridResult.continue === false) {
                            // Si ce n'est pas une actions de la grille
                            // alors on doit etre en train de charger les details
                            // On indique le chargement des details dans la status bar
                            window.sCodeLibelleStatus = DETAIL;
                            // On indique le controle ayant fait le clique
                            this.hasFocus = true;
                        }
                        resolve(actionGridResult);
                    });
                }
                //On réinit
                uiCore.setCurrentActionContext(null);
            }).catch(() => {
                // on ne fait rien
            });;

        });
    }

    // -----------------------------------------------------------------------------
    // <summary>
    //      Methode permettant de recuperer les cles primaire (et leurs valeurs) des 
    //      enregistrements selectionnes.
    //      Retourne ces information sous forme d'une chaine serialisee en JSON.
    // </summary>
    // <remarks>
    //      Cette fonction prend en paramettre un objet non-serialise.
    // </remarks>
    // <history>
    //      [JBUI]	23/06/2009	Created - DEV 26274.
    //      [JBUI]	26/06/2009	Modified - DEV 26271 : remplacement de l'IsiItemlist par Array.
    // </history>
    // Ancien nom : iws_GetListPKSelected
    // -----------------------------------------------------------------------------
    getListPKSelected(actionContext: IsiActionContext, noCheckAll: boolean): IsiDtoSelectedRecordSet {

        let enregChecked = IsiDtoSelectedRecordSet.fromJS({
            records: [],
            isAllSelected: false
        });

        if (!noCheckAll) {
            enregChecked.isAllSelected = actionContext.associatedViewContext.allLinesSelected;
        }

        // Si pas de CheckAll
        if (!enregChecked.isAllSelected) {
            enregChecked = actionContext.associatedViewContext.getSelectedRowsRealKeysValues();
        }

        return enregChecked;

    }

    getListFieldSelected(actionContext: IsiActionContext, fields: Array<string>): IsiDtoSelectedRecordSet {

        let enregChecked = IsiDtoSelectedRecordSet.fromJS({
            records: [],
            isAllSelected: false
        });

        enregChecked = actionContext.associatedViewContext.getSelectedRowsFieldsValues(fields);

        return enregChecked;

    }

    private _actionGrid(actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {

            var sNewGridName;
            let flowResult: IIsiUIFlowResult;

            flowResult = {
                result: true,
                continue: true
            };

            let manageFlow: boolean;

            // GBAU - POPIN : Déplacement de cet ligne de code ici
            // ORIC - 2006.10.17 - [TACHE:8840] : Lorsqu'une action est effectuee sur la grille,
            // on notifie le serveur que le focus devra etre fait sur la grille.
            window.iws_SaveFocusedCtrl(DIV_DETAIL);

            sNewGridName = actionContext.associatedViewContext.gridViewId;

            switch (actionContext.uiAction.key) {
                case ASSOCIATEv2:
                    manageFlow = true;

                    this.beforeAssociateOnDetail(actionContext).then((flow) => {
                        resolve(flow);
                    });
                    break;
                case DISSOCIATEv2:

                    // fonction chargee de faire tous les traitements specifiques
                    // Javascript, avant la dissociation d'enregistrement dans la vue details. 
                    // Elle doit etre surchargee dans la page.
                    manageFlow = true;
                    const dissoc = new IsiDissociationProvider();
                    dissoc.dissociate(actionContext.associatedViewContext, this).then((flow) => {
                        resolve(flow);
                    });

                    break;
                case DATA_HIERARCHICMODE_ITEM:
                    manageFlow = true;
                    const plHier = new IsiPlHierarchical();
                    plHier.changeMode(Mode.Hierarchique, actionContext.associatedViewContext, actionContext.uiAction.id).then((flow) => {
                        resolve(flow);
                    });
                    break;
                case DATA_CLASSICMODE_ITEM:
                    manageFlow = true;
                    const plFlat = new IsiPlHierarchical();
                    plFlat.changeMode(Mode.Classique, actionContext.associatedViewContext, actionContext.uiAction.id).then((flow) => {
                        resolve(flow);
                    });
                    break;
                case DATA_DELETEv2:
                    manageFlow = true;
                    const plDelete = new IsiPlDelete();
                    plDelete.deleteOnDetail().then((flow) => {
                        resolve(flow);
                    });
                    break;
                case DATA_RESTOREv2:
                    manageFlow = true;
                    const plRestore = new IsiPlRestore();
                    plRestore.restoreOnDetail().then((flow) => {
                        resolve(flow);
                    });
                    break;
                case COLLAPSEv2:
                case EXPANDv2:
                    manageFlow = true;
                    const plExpColl = new IsiPlHierarchical();
                    plExpColl.expandCollapse(actionContext.associatedViewContext.id, actionContext.uiAction.key).then((flow) => {
                        this.refresh();
                        resolve(flow);
                    });
                    break;
                case DATA_WORDv2:
                    const plMerge = new IsiPlMergeModel();

                    plMerge.launchGridMerge(actionContext.associatedViewContext.id, actionContext?.uiAction?.id);
                    manageFlow = true;
                    resolve({ result: true, continue: false });
                    break;
                case DATA_EXCELv2:
                    const plMergeExport = new IsiPlMergeModel();

                    plMergeExport.launchGridExport(actionContext.associatedViewContext);
                    manageFlow = true;
                    resolve({ result: true, continue: false });

                    break;
                case DATA_ARCHIVE_MODEv2:
                case DATA_NORMAL_MODEv2:
                    uiCore.addUITreatment({
                        func: function () {
                            window.sCodeLibelleStatus = LOADING;
                            uiCore.componentManager.getComponent<IsiGridView>(actionContext.associatedViewContext.gridViewId).clearSelectedRows();
                        }
                    });
                    break;
                case WORDv2:
                case DATA_RSSv2:
                case DATA_PROPERTYv2:
                    uiCore.addUITreatment({
                        func: function () {
                            window.sCodeLibelleStatus = LOADING;
                        }
                    });
                    break;
                case DATA_ADDv2:
                    if (uiCore.isTouchMode()) {
                        const listAddEntries = uiCore.menuManager.getEntryElementsByBarAndKey(actionContext.uiAction.menuBarId, DATA_ADDv2);
                        if (listAddEntries.length > 1 && !actionContext.uiAction.instanceName) {
                            manageFlow = true;
                            IsiAddInstancePopin.showPopin(listAddEntries, actionContext);
                        }
                    }
                    if (!manageFlow) {
                        uiCore.addUITreatment({
                            func: function () {
                                window.sCodeLibelleStatus = LOADING;
                            }
                        });
                    }
                    break;
                case MenuItemCode.TOP:
                case MenuItemCode.UP:
                case MenuItemCode.DOWN:
                case MenuItemCode.BOTTOM:
                    manageFlow = true;
                    const me: IsiDetailManager = this;
                    uiCore.addUITreatment({
                        func: function () {
                            window.sCodeLibelleStatus = LOADING;
                            let rerog = new IsiReorganizationProvider();
                            const assContext = actionContext.associatedViewContext;
                            uiCore.setModifWaitStatus(true, false, LOADING);
                            rerog.Move(uiCore.currentScreen.StateId + "|" + assContext.id, <MenuItemCode>actionContext.uiAction.key, assContext.selectedRows)
                                .done(() => {
                                    uiCore.componentManager.getComponent(assContext.gridViewId).refresh(false);
                                    me.getInstanceOfAssociatedViewFromContext(assContext).then((associatedView: IsiIWSAssociatedView) => {
                                        flowResult.continue = false;
                                        associatedView.afterMoveItem()
                                            .then(() => {
                                                uiCore.setModifWaitStatus(false, false, LOADING);
                                                resolve(flowResult);
                                            })
                                            .catch(() => {
                                                uiCore.setModifWaitStatus(false, false, LOADING);
                                                resolve(flowResult);
                                            });
                                    });

                                }).fail(() => {
                                    flowResult.result = false;
                                    uiCore.setModifWaitStatus(false, false, LOADING);
                                    resolve(flowResult);
                                }
                                );
                        }
                    });
                    break;
                case DATA_VALIDATEv2:
                    manageFlow = true;
                    this.getInstanceOfAssociatedViewFromContext(actionContext.associatedViewContext).then((assView: IsiIWSAssociatedView) => {
                        const gridView = uiCore.componentManager.getComponent<IsiGridView>(actionContext.associatedViewContext.gridViewId);

                        //Si on est en cours d'édition, on set la valeur a true pour indiquer qu'on va sauvegarder "implicitement"
                        if (gridView.isEditing()) {
                            this._btnValidateClick = true;
                        }
                        gridView.saveChanges(null, null, null);
                    });
                    break;
                case FILLREPLACEv2:
                    manageFlow = true;
                    flowResult.continue = false;

                    //On reset le timer de la page, notamment pour pas avoir un rafraichissement de la VT pendant le traitement.
                    uiCore.ClearAutoRefresh();
                    this.uploadGridState(actionContext.associatedViewContext.id);

                    // JBUI - 26.06.2009 - DEV26271 : Affichage de la popup Remplir/Remplacer
                    // AMON  06/11/2009 DYSF 30134 on doit passer l'ecran vide
                    // JSOU 05/05/2011 Redimensionnement de la glob pour le nouveau design Dev 41548     
                    IsiFillReplace().open(
                        [actionContext.associatedViewContext.id],
                        {
                            callback: (returnValue) => {
                                // Le retour de la fonction nous permet de savoir si l'on doit recharger la page
                                if (returnValue != undefined) {
                                    actionContext.associatedViewContext.clearSelectedRows()
                                    actionContext.associatedViewContext.refresh()
                                }
                                resolve(flowResult);
                            },
                            resizeToFitContent: true
                        }
                    );
                    break;
                case DATA_ARCHIVE_ONv2:
                    manageFlow = true;
                    const arch = new IsiArchiveProvider();
                    arch.archive(actionContext.associatedViewContext, actionContext).then((flow) => {
                        resolve(flow);
                    });

                    break;
                case MenuItemCode.DATA_CLOSE:
                    //On empêche le repostage
                    manageFlow = true
                    this.close(actionContext.associatedViewContext).then((flow) => {
                        //En mode recherche vt et association, si on clique sur close on fait un précédent pour retourner sur l'écran précédent
                        //L'affichage des critères est déclenché par le btn Modifier filtres
                        if (uiCore.isTabularView() &&
                            (actionContext.associatedViewContext.associatedViewState.searchType === IsiSearchType.Query ||
                                actionContext.associatedViewContext.associatedViewState.searchType === IsiSearchType.Association ||
                                actionContext.associatedViewContext.associatedViewState.searchType === IsiSearchType.TextConnexe)) {
                            window.history.back();
                        } else {
                            const verticalMenuComp = uiCore.componentManager.getComponent<any>("associatedViewFormVerticalMenu");

                            //Replie le menu des DA a la fermeture d'une DA si il n'est pas épinglé
                            if (verticalMenuComp) {
                                verticalMenuComp.isCollapsable = true;
                                verticalMenuComp.collapseIfNotPinned();
                            }
                        }
                        resolve(flow);
                    })

                    break;
                case MenuItemCode.EDIT_FILTERS:
                    //On empêche le repostage

                    manageFlow = true
                    this.close(actionContext.associatedViewContext).then((flow) => {
                        resolve(flow);
                    })
                    break;
                case DATA_DESIGN_ITEM:
                    //TABO 05/09/2016 -PB0015662  editer le design
                    beforeEditOnFormulaire(actionContext);
                    //On empêche le repostage
                    flowResult.continue = false;
                    uiCore.setSubmit(false);
                    //bSubmit = beforeEditOnFormulaire(item);
                    break;
                case DATA_REFRESH:
                    let eventIncommingFromKeyboard = actionContext.event ? actionContext.event.type === "keydown": false;

                    if (!eventIncommingFromKeyboard || !this._disableKeyboardRefresh) {
                        this._disableKeyboardRefresh = true;
                        setTimeout(() => { this._disableKeyboardRefresh = false; }, this._dureeMinimaleEntreDeuxRefresh);

                        this.currentComponent.refresh();
                    }
                    flowResult.continue = false;
                    uiCore.setSubmit(false);
                    break;
                case DATA_SELECTALL:
                    const gridViewComponent = uiCore.componentManager.getComponent<IsiGridView>(actionContext.associatedViewContext.gridViewId)
                    const stateCheck = gridViewComponent._grid._dataSource.data().length !== gridViewComponent.getSelectedRows().length
                    gridViewComponent._grid.checkUncheckAll({ grid: { dataSource: gridViewComponent._grid._dataSource }, newState: stateCheck ? "on" : "off" })

                    if (stateCheck) {
                        gridViewComponent.selectedRows.rows.forEach(row => { gridViewComponent.selectRowByPk(row.key) });
                    } else {
                        gridViewComponent.clearSelectedRows();
                    }
                    
                    flowResult.continue = false;
                    uiCore.setSubmit(false);
                    break;
                default:

                    uiCore.addUITreatment({
                        func: function (itemKey) {
                            return function () {
                                if (itemKey.length > 6 && itemKey.substr(0, 6) == "action") {
                                    // enregistrement de l'action sur la grille
                                    iws_RegisterLastAction(itemKey);
                                }
                            };
                        }(actionContext.uiAction.key)
                    });

                    break;
                //Dans le cas du marquage/demarquage d'une grille
                case DATA_MARK_ITEM:
                case DATA_UNMARK_ITEM:
                    // onrecupere la liste des elements selectionnés
                    const pk: IsiDtoSelectedRecordSet = screenCore.associatedViewManager.getListPKSelected(actionContext, false);

                    //LLGU - POPIN on gere le submit de manière asynchrone
                    uiCore.addUITreatment({
                        func: function (context) {
                            return function () {
                                const opts: MarkUnmarkOpt = {
                                    itemClick: actionContext.uiAction.key,
                                    recordSet: pk,
                                    itemGroup: actionContext.uiAction.group,
                                    inGrid: true
                                }

                                let mark: IsiPlMark = new IsiPlMark();
                                mark.MarkUnmarkRecord(opts, actionContext.associatedViewContext).then((o) => {
                                    resolve(o);
                                });

                                uiCore.setSubmit(false);
                                //On empêche le repostage
                                flowResult.continue = false;
                            }
                        }(actionContext),
                        id: "actionFormulaire_UNMARK_ITEM"
                    });
                    break;
            }

            if (!manageFlow) {
                //TODO GBAU 06/10/2020
                resolve(flowResult);
            }

        });

    }

    beforeChooseInstance(associatedViewContext: IsiIWSAssociatedViewContext): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.getInstanceOfAssociatedViewFromContext(associatedViewContext).then((associatedView) => {
                resolve(associatedView.beforeChooseInstance());
            }).catch(() => {
                reject(true);
            });
        });
    }

    promptChooseInstance(associatedViewContext: IsiIWSAssociatedViewContext, callbackFn: Function) {

        this.getInstanceOfAssociatedViewFromContext(associatedViewContext).then((associatedView) => {
            associatedView.promptChooseInstance(callbackFn);
        })
    }

    // BEFORE ASSOCIATE
    //'- MODIFICATION 
    //'- CLEM 12/05/2016 T118252 POPIN
    beforeAssociateOnDetail(actionContext: IsiActionContext): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            screenCore.interaction.promptChooseInstance(actionContext.associatedViewContext).then(
                (flow) => {
                    if (flow.continue) {
                        // il se peut que des traitements vident la valeur du champ d'instance, on le garde
                        // et on le remet apres
                        // YLAR 24/07/2012 DEV:52379: Utilisation de la VT pour l'association
                        var screenTmp = (<HTMLInputElement>document.getElementById('ihdItemClickForInstanceVT')).value;

                        // Fonction virtuelle, a redefinir dans sa propre page.
                        screenCore.afterChooseInstance(actionContext);
                        if (actionContext.afterChooseInstance) {

                            this.getInstanceOfAssociatedViewFromContext(actionContext.associatedViewContext).then((associatedView) => {
                                flow.continue = associatedView.afterChooseInstance(actionContext);
                                // YLAR 24/07/2012 DEV:52379: Utilisation de la VT pour l'association
                                (<HTMLInputElement>document.getElementById('ihdItemClickForInstanceVT')).value = screenTmp;
                            });
                        }
                        else {
                            // YLAR 24/07/2012 DEV:52379: Utilisation de la VT pour l'association
                            (<HTMLInputElement>document.getElementById('ihdItemClickForInstanceVT')).value = screenTmp;
                        }
                    }
                    resolve(flow);
                }

            );
        })
    }

    /*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : TGOU
'- Date        : 14/09/2007
'- Description : Force la validation d une cellule dans un detail pour la validation.
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'-	 -> gridName : id de la grille
'-----------------------------------------------------------------------------------------*/
    saveChanges(gridView: IsiGridView, postBack: boolean, callBackOk: Function, resolve: (flow: IIsiUIFlowResult) => void, reject: (flow: IIsiUIFlowResultGeneric<string>) => void, dsAdapter: IIsiGridValidationContext): void {

        gridView.saveChanges(dsAdapter, (_data: any, _textStatus: string, _jqXHR: any) => {
            let updatedRows = dsAdapter.getUpdatedRowsDatas();
            //Si d'autres données de la ligne ont été modifiées côté serveur, on met a jour les cellules correspondantes
            if (gridView.getGridSaveMode() === 1) { //En mode explicit, c'est un tableau d'entité qui est retourné pour gérer la modif de batch
                _data.forEach((entity) => {
                    dsAdapter.updateGridWithUpdatedEntity(entity.DynamicProperties, updatedRows[entity.DynamicProperties.PrimaryKey]);
                });
            } else {
                dsAdapter.updateGridWithUpdatedEntity(_data.DynamicProperties, updatedRows[_data.DynamicProperties.PrimaryKey]);

            }
            callBackOk(_data);
            resolve({
                continue: postBack,
                result: true
            });
        },
            (_jqXHR: any, _textStatus: string, _errorThrown: string) => {
                let errMsg: string = "";
                if (_jqXHR.responseJSON && _jqXHR.responseJSON.ExceptionMessage) {
                    errMsg = _jqXHR.responseJSON.ExceptionMessage;
                }
                reject({ continue: false, result: false, reponse: errMsg });
                gridView.refresh();
            });

    }

    /** Transmet l'état de la grille coté serveur */
    public async uploadGridState(assId): Promise<IIsiUIFlowResult> {
        const plAssociatedViewManager = new IsiPlAssociatedViewManager();
        await plAssociatedViewManager.uploadClientState(clientState.associatedViewManager.states[assId]);
        return { continue: true, result: true };
    }

    /**
     * Définit l'id de la DA visible
     * @param assId
     */
    public setShownContextId(assId: string) {
        this._state.shownContextId = assId;
    }

}

/*Classe stockant le comportement specifique de l'application pour rendu de la grille RWD*/
class IsiDetailRWD {
    getHeaderComponentId() {
        return "AssociatedView_Header";
    }
}

/*Classe stockant le comportement specifique de l'application pour rendu de la grille RWD*/
class IsiDetailVintage {
    getHeaderComponentId() {
        return "AssociatedViewHeader";
    }
}

//class Draggable {
//    element: any;
//    previousCursorPosition: any;
//    mouseDown: boolean;
//    selectedOverlayIndex: any;

//    constructor(element) {
//        this.element = element;
//        element.addEventListener('click', this.mouseClicked.bind(this));
//        element.addEventListener('mousemove', this.mouseMoving.bind(this));
//        element.addEventListener('mouseup', this.mouseRemoved.bind(this));
//    }
//    setPreviousCursorPosition(event) {
//        this.previousCursorPosition = {
//            x: event.clientX,
//            y: event.clientY
//        };
//    }
//    mouseClicked(event) {
//        this.setPreviousCursorPosition(event);
//        this.mouseDown = true;
//        this.selectedOverlayIndex = event.target.dataset.index;
//    }
//    mouseMoving(event) {
//        if (!this.mouseDown) return
//        let parent = event.target.parentElement;

//        function toNumber(val) {
//            return Number(val.replace('%'));
//        }
//        let dx = event.clientX - this.previousCursorPosition.x;
//        let dy = event.clientY - this.previousCursorPosition.y;

//        function percentageToPixel(x, y) {
//            return {
//                x: parent.offsetWidth * (x / 100),
//                y: parent.offsetHeight * (y / 100)
//            };
//        }
//        function pixelToPercentage(x, y) {
//            return {
//                y: (y / parent.offsetHeight) * 100,
//                x: (x / parent.offsetWidth) * 100
//            };
//        }
//        let pixelPosition = percentageToPixel(toNumber(this.element.style.left), toNumber(this.element.style.top));
//        let top = pixelPosition.y + dy;
//        let left = pixelPosition.x + dx;
//        let percentagePosition = pixelToPercentage(left, top);
//        this.element.style.top = percentagePosition.y + '%';
//        this.element.style.left = percentagePosition.x + '%';
//    }

//    mouseRemoved() {
//        this.mouseDown = false;
//    }
//}
